module.exports = __webpack_public_path__ + "img/ups_icon.adb7313b.svg";